( function() {
    "use strict";

    angular
        .module( 'ccsTrApp' )
        .service( 'CommentCustomService', CommentCustomService );

    CommentCustomService.$inject = [ '$http' ];

    function CommentCustomService( $http ) {
        return {
            returnCommentsByLot: returnCommentsByLot,
            returnCommentsByShipment: returnCommentsByShipment,
            returnCommentsByContract: returnCommentsByContract,
            returnCommentsByInvoice: returnCommentsByInvoice,
            returnCommentsByRequiredDocument: returnCommentsByRequriedDocument,
            returnCommentsByController: returnCommentsByController,
            returnCommentsByControllerPayment: returnCommentsByControllerPayment,
            returnCommentAuditById: returnCommentAuditById,
            assignParentToComment: assignParentToComment
        };

        function returnCommentsByLot( id ) {
            var url = "api/comments/lot/" + id;
            return $http.get( url );
        }

        function returnCommentsByShipment( id ) {
            var url = "api/comments/shipment/" + id;
            return $http.get( url );
        }

        function returnCommentsByContract( id ) {
            var url = "api/comments/contract/" + id;
            return $http.get( url );
        }

        function returnCommentsByInvoice( id ) {
            var url = "api/comments/invoice/" + id;
            return $http.get( url );
        }

        function returnCommentsByRequriedDocument(id) {
            var url = "api/comments/required-document/" + id;
            return $http.get(url);
        }

        function returnCommentsByController(id) {
            var url = "api/comments/controller/" + id;
            return $http.get(url);
        }

        function returnCommentsByControllerPayment(id) {
            var url = "api/comments/controller-payment/" + id;
            return $http.get(url);
        }

        function returnCommentAuditById( id ) {
            var url = "jv/audit/comment/" + id;
            return $http.get( url );
        }

        function assignParentToComment( comments, id, type ) {
            var url = "api/comments/bulk?type=" + type + "&id=" + id;
            return $http({
                url: url,
                method: "POST",
                data: comments,
                headers: { 'Content-Type': 'application/json' }
            });
        }
    }
})();
